import { createPinia } from 'pinia';
import { createStatePersistence } from 'pinia-plugin-state-persistence';

const pinia = createPinia();

// Use the plugin with default localStorage
pinia.use(
  createStatePersistence({
    debug: import.meta.env.DEV,
  }),
);

export default pinia;
